<!--eslint-disable-->
<template>
  <v-container id="grid" fluid grid-list-sm tag="section">
    <div v-if="isLoad" class="text-xs-center">
      <v-progress-circular
        :indeterminate="isLoad"
        color="primary"
      ></v-progress-circular>
    </div>
    <v-layout column>
      <v-flex xs12 sm6 md8 align-center layout text-xs-left>
        <v-card flat>
          <!-- <v-avatar :tile="tile" :size="70" color="grey lighten-4">
            <img v-bind:src="partner.styles.partner_logo" alt="logo" />
          </v-avatar> -->

          <v-card-text
            style="border: 1px solid #ccc; margin-top: 20px; width: 800px"
          >
            <div><b class="grey--text">Dados do Estabelecimento</b></div>
            <div>
              <b>Nome Fantasia: </b>
              <p>{{ partner.fantasy_name }}</p>
            </div>
            <div>
              <b>CNPJ: </b>
              <p>
                {{ formatCnpj(partner.cnpj) }}
              </p>
            </div>
            <b>Representante: </b>
            <p>{{ partner.owner_name }}</p>
            <b>CPF do Representante: </b>
            <p>{{ formatCpf(partner.cpf) }}</p>
            <b>RG do Titular: </b>
            <p>{{ partner.bank_account_attributes.document_number }}</p>
            <b>Tipo de Conta: </b>
            <p>{{ partner.account_type ? $t(`account_type.${partner.account_type}`) : '-' }}</p>
            <div>
              <b>Ramo de Atividade: </b>
              <p>{{ partner.category_description }}</p>
            </div>
            <b>Email: </b>
            <div>
              <a :href="`mailto:${partner.email}`" class="blue--text">
                {{ partner.email }}
              </a>
            </div>
            <b>Data de Cadastro: </b>
            <p>{{ $d(new Date(partner.created_at), "short") }}</p>
          </v-card-text>

          <v-card-text
            style="border: 1px solid #ccc; margin-top: 20px; width: 800px"
          >
            <div><b class="grey--text">Endereço</b></div>
            <b>Rua/Avenida:</b>
            <p>{{ partner.address_attributes.street }}</p>
            <b>Número: </b>
            <p>{{ partner.address_attributes.number }}</p>
            <b>Complemento: </b>
            <p>{{ partner.address_attributes.complement }}</p>
            <b>Bairro: </b>
            <p>{{ partner.address_attributes.district }}</p>
            <b>Cidade: </b>
            <p>{{ partner.address_attributes.city }}</p>
            <b>Estado: </b>
            <p>{{ partner.address_attributes.state }}</p>
            <b>Telefone: </b>
            <p>
              ({{ partner.phones_attributes.area }})
              {{ partner.phones_attributes.number }}
            </p>
            <b>Operadora: </b>
            <p>
              {{ partner.chip }}
            </p>
          </v-card-text>

          <v-card-text
            style="border: 1px solid #ccc; margin-top: 20px; width: 800px"
          >
            <div>
              <b class="grey--text">Dados Bancários</b>
            </div>
            <b>Típo de Conta: </b>
            <p>
              {{ onAbbreviate(partner.bank_account_attributes.kind) }}
            </p>
            <b>Agência: </b>
            <p>
              {{ partner.bank_account_attributes.agency }}
            </p>
            <b>Dígito: </b>
            <p>
              {{ partner.bank_account_attributes.agency_digit }}
            </p>

            <b>Conta: </b>
            <p>
              {{ partner.bank_account_attributes.number }}
            </p>
            <b>Dígito:</b>
            <p>
              {{ partner.bank_account_attributes.number_digit }}
            </p>
            <b>Titular: </b>
            <p>
              {{ partner.bank_account_attributes.holder_name }}
            </p>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";

export default {
  name: "Details",
  created() {
    this.$store.dispatch("partners/get", this.$route.params.id);
  },
  computed: {
    ...mapGetters({
      partner: "partners/partner",
      isLoad: "partners/isLoad",
    }),
  },
  methods: {
    ...mapActions({}),

    goTo(route) {
      this.$router.push({ name: route });
      this.hideNavigation();
    },

    onAbbreviate(text) {
      if (text === "CC") {
        return "Conta Corrente";
      }
      return "Conta Poupança";
    },
    onCaptalize(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    formatCnpj(value) {
      return value.replace(
        /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
        "$1.$2.$3/$4-$5"
      );
    },
    formatCpf(value) {
      return value.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    },
  },
};
</script>
<style >
.v-chip.partner {
  background-color: #1b5e20 !important;
}
</style>
